import React, { type FC, useCallback, useEffect, useState } from 'react';

import cn from 'classnames';

import { isMedia } from '@shared/lib/html';
import { Button } from '@shared/ui/button';
import { DialPad, type DialPadSubmitPayload } from '@shared/ui/dial-pad';
import { Heading } from '@shared/ui/heading';
import { Toggle } from '@shared/ui/toggle';
import IconClose from '@assets/img/icons/close-x.svg';
import IconUserMove from '@assets/img/icons/user-move.svg';

import { useDialPadSearch } from '../../hooks';
import { ITransferPanel } from './types';

import styles from './styles.module.scss';

export const TransferPanel: FC<ITransferPanel> = ({ isOpened, onClose, onRefer, disabledCall }) => {
	const [isToggle, setIsToggle] = useState(false);
	const handleResolvedDialPadSubmit = useCallback(
		({ aor, displayName }: DialPadSubmitPayload) => {
			onRefer({ aor, displayName });
		},
		[onRefer]
	);
	const {
		suggestions: dialPadSuggestions,
		onQueryChange: handleDialPadQueryChange,
		onSubmit: handleDialPadSearchSubmit,
	} = useDialPadSearch(handleResolvedDialPadSubmit);

	const freezeBodyScroll = (isFreeze: boolean) => {
		const { body } = document;

		if (isFreeze) {
			body.classList.add(styles.Freeze);
			const { scrollY } = window;
			body.style.position = 'fixed';
			body.style.top = `-${scrollY}px`;
		} else {
			body.classList.remove(styles.Freeze);
			const scrollY = body.style.top;
			body.style.position = '';
			body.style.top = '';
			window.scrollTo(0, Number.parseInt(scrollY || '0', 10) * -1);
		}
	};

	useEffect(() => {
		const onWindowResize = () => {
			if (!isMedia('sm')) {
				onClose();
			}
		};

		window.addEventListener('resize', onWindowResize);

		return () => window.removeEventListener('resize', onWindowResize);
	}, []);

	useEffect(() => {
		// for mobile only
		if (isMedia('sm')) freezeBodyScroll(isOpened);
	}, [isOpened]);

	const handleToggleClick = () => {
		setIsToggle((s) => !s);
	};

	return (
		<div className={cn(styles.PanelWrapper, { [styles.active]: isOpened })}>
			<div className={styles.Headline}>
				<Heading noMargin className={styles.HeadlineText} size="h4">
					<span
						className={styles.HeadlineIcon}
						dangerouslySetInnerHTML={{ __html: IconUserMove }}
					/>
					Перевод звонка
				</Heading>
				<Button buttonType="icon" svg={IconClose} onClick={onClose} />
			</div>
			<div className={styles.PanelContent}>
				<div>
					<DialPad
						classNames={styles.DialPadWrapper}
						disabledCall={disabledCall}
						suggestions={dialPadSuggestions}
						textButton="Перевести"
						onClick={handleDialPadSearchSubmit}
						onQueryChange={handleDialPadQueryChange}
					/>
					<div className={styles.ToggleWrapper}>
						<Toggle
							boldText
							isLeftSideText
							checked={isToggle}
							text="Перезвонить, если нет ответа"
							onChange={handleToggleClick}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
